import { GeoSystemTypes } from 'utils/enums/geo-system-types';
import { MeasureSystem } from 'utils/hooks/measure-system-type';

const METERS_PER_FOOT = 0.3048;
const FEET_PER_MILE = 5280;

export const formatMeasurementDistance = (
  distanceInMeters: number,
  geoSystemType: GeoSystemTypes,
  converter: MeasureSystem['converter'],
): string => {
  if (geoSystemType === GeoSystemTypes.Imperial) {
    const feet = distanceInMeters / METERS_PER_FOOT;

    if (feet >= FEET_PER_MILE) {
      return `${converter(distanceInMeters, 'meters', 'kilometers').toFixed(2)} mi`;
    }

    return `${Math.round(feet)} ft`;
  }

  if (distanceInMeters >= 1000) {
    return `${converter(distanceInMeters, 'meters', 'kilometers').toFixed(2)} km`;
  }

  return `${Math.round(distanceInMeters)} m`;
};

export const drawOptions = {
  rectangle: false,
  polyline: false,
  polygon: true,
  circle: false,
  marker: false,
  circlemarker: false,
};

export enum ControlMapPosition {
  TopLeft = 'topleft',
  TopRight = 'topright',
  BottomLeft = 'bottomleft',
  BottomRight = 'bottomright',
}
